import { useEditor, EditorContent } from '@tiptap/react'
import StarterKit from '@tiptap/starter-kit'
import Image from '@tiptap/extension-image'
import Link from '@tiptap/extension-link'
import { Bold, Italic, List, ListOrdered, Image as ImageIcon, Link as LinkIcon, Undo, Redo } from 'lucide-react'

export default function TipTapEditor({ value, onChange }) {
  const editor = useEditor({
    extensions: [StarterKit, Image, Link.configure({ openOnClick: false })],
    content: value || '<p></p>',
    onUpdate: ({ editor }) => {
      onChange(editor.getHTML())
    },
  })

  if (!editor) return null

  const btn = (active, onClick, Icon, title) => (
    <button
      type="button"
      onClick={onClick}
      title={title}
      className={`rounded-md p-1.5 transition-colors ${active ? 'bg-orken-accent text-[#0d1f12]' : 'text-orken-dim hover:bg-white/5 hover:text-white'}`}
    >
      <Icon size={16} />
    </button>
  )

  const addImage = () => {
    const url = prompt('URL da imagem')
    if (url) editor.chain().focus().setImage({ src: url }).run()
  }

  const addLink = () => {
    const url = prompt('URL do link')
    if (url) editor.chain().focus().setLink({ href: url }).run()
  }

  return (
    <div className="rounded-lg border border-orken-border bg-orken-bg-card overflow-hidden">
      <div className="flex items-center gap-1 border-b border-orken-border px-3 py-2 bg-orken-bg-2 flex-wrap">
        {btn(editor.isActive('bold'), () => editor.chain().focus().toggleBold().run(), Bold, 'Negrito')}
        {btn(editor.isActive('italic'), () => editor.chain().focus().toggleItalic().run(), Italic, 'Itálico')}
        <div className="mx-1 h-4 w-px bg-orken-border" />
        {btn(editor.isActive('bulletList'), () => editor.chain().focus().toggleBulletList().run(), List, 'Lista')}
        {btn(editor.isActive('orderedList'), () => editor.chain().focus().toggleOrderedList().run(), ListOrdered, 'Lista numerada')}
        <div className="mx-1 h-4 w-px bg-orken-border" />
        {btn(false, addImage, ImageIcon, 'Imagem')}
        {btn(editor.isActive('link'), addLink, LinkIcon, 'Link')}
        <div className="mx-1 h-4 w-px bg-orken-border" />
        {btn(false, () => editor.chain().focus().undo().run(), Undo, 'Desfazer')}
        {btn(false, () => editor.chain().focus().redo().run(), Redo, 'Refazer')}
      </div>
      <div className="p-4 min-h-[300px]">
        <EditorContent editor={editor} className="prose prose-invert max-w-none text-sm text-white focus:outline-none" />
      </div>
    </div>
  )
}
